import { Component, OnInit } from '@angular/core';
import { TipoTransacao } from '../../enums/TipoTransacao.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-notas-list',
  templateUrl: './notas-list.component.html',
  styleUrl: './notas-list.component.scss',
})
export class NotasListComponent implements OnInit {

  tipoTransacaoAtual?: TipoTransacao;
  ehTipoTransacaoVenda = false;
  ehTipoTransacaoCompra = false;
  ehTipoTransacaoDevolucaoDeCompra = false;
  ehTipoTransacaoDevolucao = false;

  actionLabel = '';
  actionRoute = '';

  // Filtro por pessoa (queryParam pessoaId - acoes rapidas de clientes)
  pessoaIdFiltro: number | undefined;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    // Usar apenas o path sem queryParams para comparacao
    const currentPath = this.router.url.split('?')[0];

    if (currentPath === '/compras-list') {
      this.tipoTransacaoAtual = TipoTransacao.COMPRA;
      this.ehTipoTransacaoCompra = true;
      this.actionLabel = this.translate.instant('notas-list.botoes.nova_compra');
      this.actionRoute = '/adicionar-compra';
    } else if (currentPath === '/vendas-list') {
      this.tipoTransacaoAtual = TipoTransacao.VENDA;
      this.ehTipoTransacaoVenda = true;
    } else if (currentPath === '/devolucao-compras') {
      this.tipoTransacaoAtual = TipoTransacao.DEVOLUCAO_DE_COMPRA;
      this.ehTipoTransacaoDevolucaoDeCompra = true;
    } else if (currentPath === '/devolucao-vendas') {
      this.tipoTransacaoAtual = TipoTransacao.DEVOLUCAO;
      this.ehTipoTransacaoDevolucao = true;
    }

    // Ler pessoaId dos queryParams para filtro por pessoa
    const pessoaIdParam = this.route.snapshot.queryParams['pessoaId'];
    if (pessoaIdParam) {
      this.pessoaIdFiltro = Number(pessoaIdParam);
    }
  }
}
